import { InfoIcon } from "lucide-react";

import { Row } from "@/components";

export const IntakeGuidance = ({ message }: { message: string }) => (
  <Row className="items-start gap-3 rounded-lg border border-slate-200 bg-slate-50 px-4 py-3.5">
    <InfoIcon className="mt-0.5 shrink-0 text-blue-400" size={18} />
    <div>
      <p className="mb-0.5 text-[0.7rem] font-semibold uppercase tracking-wide text-blue-400">
        Guidance
      </p>
      <p className="text-[0.85rem] text-gray-600">{message}</p>
    </div>
  </Row>
);
